export const preferredDealerConfig = {
  change: {
    successMessageTimeout: 5000,
    status: {
      failure: 'failure',
      pending: 'pending',
      success: 'success'
    }
  }
};